module.exports = require('./helpers/bundle-url').getBundleURL('9p9yL') + "CourierPrime-Regular.3a25a501.ttf";